module.exports = __webpack_public_path__ + "img/人才中心_BANNER.2fe077ae.jpg";